import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { app } from '../firebase/config';

const db = getFirestore(app);

export const getActivities = async () => {
  try {
    if (!db) {
      throw new Error('Database connection error');
    }

    const activitiesRef = collection(db, 'activities');
    const activitiesSnapshot = await getDocs(activitiesRef);
    
    if (activitiesSnapshot.empty) {
      return [];
    }

    const activities = activitiesSnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.ActivityName || data.activityName || 'Untitled Activity',
        instructions: data.Instructions || data.instructions || 'No instructions provided',
        skillTags: typeof (data.SkillTags || data.skillTags) === 'string' 
          ? (data.SkillTags || data.skillTags).split(', ') 
          : (data.SkillTags || data.skillTags || []),
        videoUrl: data.VideoURL || data.videoUrl || null
      };
    });

    return activities;

  } catch (error) {
    console.error('Error fetching activities:', error);
    throw new Error('Failed to load activities. Please try again later.');
  }
}; 